import { gql } from '@apollo/client';

export interface ISubscription {
  id: string;
  active: boolean;
  state: 'active' | 'trial' | 'inactive' | 'canceled';
  display: string;
  next: string;
  begin: string;
  intervalUnit: string;
  nextChargeTotalDisplay: string;
  nextChargeDate: string;
  trial_since: number;
  endDisplay: string;
  paymentProvider?: 'fastspring' | 'stripe' | null;
}

export const SubscriptionFragment = gql`
  fragment SubscriptionFragment on Subscription {
    id
    active
    state
    display
    next
    begin
    intervalUnit
    nextChargeTotalDisplay
    nextChargeDate
    trial_since
    endDisplay
    paymentProvider
  }
`;
